import React from "react";
import { Redirect, Route, Switch, useHistory, useLocation, useParams } from "react-router";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import { Tabs } from "src/components/NavTabs/Tabs";
import * as S from "../../../constants/StringConstants";
import BrokerApps from "../BrokerApps/BrokerApps";
import BrokerBuilder from "../BrokerBuilder";
import BrokerComments from "../BrokerComments/BrokerComments";
import BrokerCommissions from "../BrokerCommissions/BrokerCommissions";
import BrokerContracts from "../BrokerContracts/BrokerContracts";
import BrokerDocs from "../BrokerDocs/BrokerDocs";
import BrokerTasks from "../BrokerTasks/BrokerTasks";
import "./../BrokerBuilder.scss";
import "./../BrokerContainer/BrokerContainer.scss";

export const pages = [
  { path: "details", name: S.BRO_DETAILS_TAB, component: BrokerBuilder },
  { path: "contracting", name: S.BRO_CONTRACTING_TAB, component: BrokerContracts },
  { path: "commissions", name: S.BRO_COMMISSIONS_TAB, component: BrokerCommissions },
  { path: "documentation", name: S.BRO_DOCUMENTATION_TAB, component: BrokerDocs },
  { path: "applications", name: S.BRO_APPS_TAB, component: BrokerApps },
  { path: "comments", name: S.BRO_COMMENTS_TAB, component: BrokerComments },
  { path: "tasks", name: S.BRO_TASKS_TAB, component: BrokerTasks },
];

export const BrokerContainer = props => {
  const location = useLocation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  // Highlight Active Tab
  const pathNameRegex = /\/([a-zA-Z0-9]+)$/;
  const match = pathNameRegex.exec(location.pathname);
  const pathname = match ? match[1] : "";

  const isNew = id === "new";

  return (
    <div className="broker-builder">
      <AppBar icon={IconName.Brokers} title={S.BRO_NEW_TITLE} />

      <div className="broker__links">
        <Tabs
          pages={pages}
          pathname={pathname}
          isNew={isNew}
          id={id}
          setChangeToURL={url => history.push(url)}
          basePath="brokers"
        />
      </div>

      <main className="broker__wrap">
        <section className="broker__container">
          <Switch>
            {pages.map(({ path, component: Component }, index) => (
              <Route key={index} path={`/brokers/:id/${path}`} render={props => <Component {...(props as any)} />} />
            ))}
            <Route path="/brokers/new" render={props => <BrokerBuilder {...(props as any)} />} />
            {id && <Redirect to={`/brokers/${id}/details`} />}
          </Switch>
        </section>
      </main>
    </div>
  );
};
